import { Modal } from '@mantine/core';
import StripoTemplatesPage from '../../pages/stripoTemplates/StripoTemplatesPage';

const TemplatesGalleryModal = ({ show, close }) => {
  return (
    <Modal size="full" opened={show} onClose={close} title="Email Gallery">
      <StripoTemplatesPage close={close} />
    </Modal>
  );
};

export default TemplatesGalleryModal;
